import { asMultiStyleConfig } from '../../utils/theme';
var parts = ['container', 'dot'];
var containerStyles = {
  display: 'flex',
  flexDirection: 'row',
  gap: '.75rem'
};
var toggleStyles = {
  display: 'inline-block',
  width: '.75rem',
  height: '.75rem',
  borderRadius: '50%',
  bg: 'grey.400',
  border: "1px solid",
  borderColor: 'grey.300',
  position: 'relative',
  _after: {
    content: '""',
    display: 'block',
    width: 'calc(100% + 10px)',
    height: 'calc(100% + 12px)',
    bg: 'transparent',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)'
  },
  _focus: {
    boxShadow: '0 0 0.125rem 0.125rem #00CAFF',
    outline: 'none'
  },
  _checked: {
    bg: 'blue.700',
    borderColor: 'blue.600'
  },
  _hover: {
    cursor: 'pointer'
  },
  _readOnly: {
    cursor: 'default',
    boxShadow: 'none'
  }
};
var baseStyle = () => ({
  container: containerStyles,
  toggle: toggleStyles
});
export default asMultiStyleConfig({
  parts,
  baseStyle
});